module.exports = __webpack_public_path__ + "r-v3/img/sticker_20.7ea5b51a.svg";